export default __webpack_public_path__ + "static/fnaimv-549321eb66f71180c60037c4ad5eb2eb.png";